import { Title } from './Title';

export type { TypeTitleProps } from './types';
export default Title;
